import React from 'react';
import './Modal.styles.scss';

function Modal({ isOpened, close, children, closeOnOverlayClick = true }) {
    return (
        <div className="modal-wrap">
            <div className={`modal ${isOpened ? 'modal--visible' : ''} `}>
                <div
                    className={`page-overlay ${isOpened ? 'page-overlay--visible' : ''}`}
                    onClick={closeOnOverlayClick ? close : () => {}}
                >
                    <div
                        className="modal__inner"
                        onClick={(event) => event.stopPropagation()}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal;